(function () {
  'use strict';

  if (window.__ValsoleAnalyticsS152Loaded) return;
  window.__ValsoleAnalyticsS152Loaded = true;

  var context = window.ValsoleS152Context || {};
  var memorySessionId = '';
  var emittedOnce = {};
  var lastAtcIntentAt = 0;
  var sequence = 0;
  var schemaVersion = 's152_v1';
  var themeVersion = context.theme_version || 's152_conversion_path';
  var allowedParams = {
    lm_source: true,
    lm_surface: true,
    lm_variant: true,
    qm_source: true,
    utm_source: true,
    utm_medium: true,
    utm_campaign: true
  };

  function clean(value, maxLength) {
    var text = String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
    if (!maxLength || text.length <= maxLength) return text;
    return text.slice(0, maxLength);
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function normalizePath(pathname) {
    var path = clean(pathname) || '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    path = path.replace(/\/{2,}/g, '/');
    if (path.length > 1) path = path.replace(/\/+$/, '');
    return path.toLowerCase();
  }

  function safeUrl(rawUrl) {
    try {
      return new URL(rawUrl || window.location.href, window.location.origin);
    } catch (error) {
      return new URL(window.location.href);
    }
  }

  function whitelistedQuery(search) {
    var params = new URLSearchParams(search || '');
    var kept = [];
    params.forEach(function (value, key) {
      if (!allowedParams[key]) return;
      var cleaned = clean(value, 100);
      if (!cleaned) return;
      kept.push(encodeURIComponent(key) + '=' + encodeURIComponent(cleaned));
    });
    return kept.join('&');
  }

  function destinationMeta(rawUrl) {
    var url = safeUrl(rawUrl);
    return {
      destination_path: normalizePath(url.pathname),
      destination_query_whitelisted: whitelistedQuery(url.search)
    };
  }

  function deviceType() {
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return 'mobile';
    if (window.matchMedia && window.matchMedia('(max-width: 991px)').matches) return 'tablet';
    return 'desktop';
  }

  function landingBucket(pathname) {
    var path = normalizePath(pathname || window.location.pathname);
    if (path === '/') return 'home';
    if (path.indexOf('/collections/') === 0 || path === '/collections') return 'collection';
    if (path.indexOf('/products/') === 0) return 'pdp';
    if (path.indexOf('/cart') === 0) return 'cart';
    if (path.indexOf('/blogs/news') === 0) return 'news';
    if (path.indexOf('/blogs/') === 0) return 'blog';
    if (path.indexOf('/pages/quick-match') === 0) return 'quick_match';
    if (path.indexOf('/pages/') === 0) return 'guide';
    if (path.indexOf('/policies/') === 0) return 'policy';
    return 'other';
  }

  function referrerType() {
    if (!document.referrer) return 'direct';
    try {
      var referrer = new URL(document.referrer);
      if (referrer.origin === window.location.origin) return 'internal';
      return 'external';
    } catch (error) {
      return 'unknown';
    }
  }

  function getSessionId() {
    if (memorySessionId) return memorySessionId;
    try {
      memorySessionId = window.sessionStorage.getItem('vs_session_id') || '';
      if (!memorySessionId) {
        memorySessionId = 'vs_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
        window.sessionStorage.setItem('vs_session_id', memorySessionId);
      }
    } catch (error) {
      memorySessionId = memorySessionId || ('vs_mem_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10));
    }
    return memorySessionId;
  }

  function currentVariant() {
    var variantId = '';
    var variant = null;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"], [data-pdp-sticky-atc-select]');
    if (input) variantId = clean(input.value);
    if (!variantId && context.product) variantId = clean(context.product.variant_id);
    if (window.product && Array.isArray(window.product.variants) && variantId) {
      variant = window.product.variants.find(function (item) {
        return String(item && item.id) === String(variantId);
      }) || null;
    }
    return {
      variant_id: variantId,
      variant_title: clean((variant && (variant.public_title || variant.title)) || (context.product && context.product.variant_title), 120),
      price: toNumber((variant && variant.price) || (context.product && context.product.price)),
      available: typeof (variant && variant.available) === 'boolean' ? variant.available : (context.product ? context.product.available : null)
    };
  }

  function activeOption(namePart) {
    var containers = Array.prototype.slice.call(document.querySelectorAll('.product-option-container[data-option-name]'));
    var match = containers.find(function (container) {
      return clean(container.getAttribute('data-option-name')).toLowerCase().indexOf(namePart) !== -1;
    });
    if (!match) return '';
    var active = match.querySelector('.option-pill.is-active, .product-option-value.is-active, .size-selector-value.is-active');
    if (active) return clean(active.getAttribute('data-value') || active.textContent, 120);
    var select = match.querySelector('select.product-option-hidden-select, select');
    return select ? clean(select.value, 120) : '';
  }

  function basePayload() {
    var url = safeUrl(window.location.href);
    var market = context.market || {};
    var payload = {
      event_category: 'conversion_diagnostic',
      schema_version: schemaVersion,
      theme_version: themeVersion,
      vs_session_id: getSessionId(),
      event_sequence: ++sequence,
      event_timestamp: new Date().toISOString(),
      page_type: context.page_type || '',
      template_name: context.template_name || '',
      template_suffix: context.template_suffix || '',
      page_path: normalizePath(url.pathname),
      page_query_whitelisted: whitelistedQuery(url.search),
      page_title: clean(document.title, 160),
      referrer_type: referrerType(),
      landing_bucket: landingBucket(url.pathname),
      device_type: deviceType(),
      viewport_width: window.innerWidth || null,
      viewport_height: window.innerHeight || null,
      cart_item_count: toNumber(context.cart_item_count),
      market_country: clean(market.country_iso_code || market.country_name || '', 80),
      market_country_name: clean(market.country_name || '', 80),
      market_currency: clean(market.currency_iso_code || '', 12),
      market_language: clean(market.language_iso_code || '', 20),
      market_root_url: clean(market.root_url || '', 80)
    };
    if (context.collection && context.collection.handle) payload.collection_handle = context.collection.handle;
    if (context.product && context.product.handle) payload.product_handle = context.product.handle;
    if (context.article && context.article.handle) {
      payload.content_handle = context.article.handle;
      payload.content_type = 'article';
    }
    if (context.blog && context.blog.handle) payload.blog_handle = context.blog.handle;
    return payload;
  }

  function sanitizePayload(payload) {
    var cleaned = {};
    Object.keys(payload || {}).forEach(function (key) {
      var value = payload[key];
      if (value == null || value === '') return;
      if (typeof value === 'string') cleaned[key] = clean(value, key.indexOf('message') !== -1 ? 120 : 180);
      else cleaned[key] = value;
    });
    return cleaned;
  }

  function forwardToGtag(eventName, payload) {
    if (typeof window.gtag !== 'function') return;
    var params = Object.assign({}, payload || {});
    delete params.event;
    params.event_category = params.event_category || 'valsole_diagnostics';
    params.transport_type = params.transport_type || 'beacon';
    try {
      window.gtag('event', eventName, params);
    } catch (error) {}
  }

  function emit(eventName, detail, options) {
    if (!eventName) return;
    var onceKey = options && options.onceKey;
    if (onceKey && emittedOnce[onceKey]) return;
    if (onceKey) emittedOnce[onceKey] = true;

    window.dataLayer = window.dataLayer || [];
    var payload = sanitizePayload(Object.assign(basePayload(), detail || {}, { event: eventName }));
    window.dataLayer.push(payload);
    forwardToGtag(eventName, payload);

    try {
      document.dispatchEvent(new CustomEvent('valsole:analytics:s152', { detail: payload }));
    } catch (error) {}
  }

  window.ValsoleAnalytics = window.ValsoleAnalytics || {};
  window.ValsoleAnalytics.emit = emit;
  window.ValsoleAnalytics.s152 = {
    emit: emit,
    sessionId: getSessionId,
    version: themeVersion
  };

  function inferModule(node) {
    if (!node || !node.closest) return 'unknown';
    var explicit = node.closest('[data-s152-module]');
    if (explicit) return clean(explicit.getAttribute('data-s152-module')) || 'unknown';
    if (node.closest('.pdp_wrapper, .pdp-main, .section_product, .section_pdp-hero, [data-product-handle]')) return 'pdp';
    if (node.closest('.section_hero[data-hero-section-id], .section_hero:not(.section_pdp-hero), .home-hero')) return 'home_hero';
    if (node.closest('.section_meet-the-insoles, .feature-benefit-cards, [id*="feature_benefit"]')) return 'homepage_shop_by_need';
    if (node.closest('.homepage-product-paths, [id*="homepage_product_paths"]')) return 'homepage_product_paths';
    if (node.closest('.blog-preview, .home-news-entry, [id*="blog_preview"], [id*="home_news"]')) return 'homepage_blog_preview';
    if (node.closest('.content-commerce-bridge, .article-mentioned-products, [data-vs-content-commerce-bridge]')) return 'blog_product_module';
    if (node.closest('.collection-insoles-intent-router, [data-vs-collection-intent-router]')) return 'collection_intent_router';
    if (node.closest('.pdp-content-entry-bridge, [data-vs-pdp-content-entry-bridge]')) return 'pdp_content_entry_bridge';
    if (node.closest('.vl-newsroom-main, .newsroom, .news-article, .blog_main, .article-preview-grid-newsletter')) return 'content';
    if (node.closest('.section_shop-products, .collection-need-router, .collection-fast-paths')) return 'collection';
    if (node.closest('.cart-popup_component, .cart-drawer, .val-cart-page')) return 'cart';
    if (node.closest('header, .header, .navbar')) return 'header';
    return 'unknown';
  }

  function elementPosition(node, selector) {
    if (!node || !node.parentElement) return '';
    var siblings = Array.prototype.slice.call(node.parentElement.querySelectorAll(selector));
    var index = siblings.indexOf(node);
    return index >= 0 ? index + 1 : '';
  }

  function productHandleFromUrl(rawUrl) {
    var path = destinationMeta(rawUrl).destination_path;
    var match = path.match(/\/products\/([^/?#]+)/);
    return match && match[1] ? match[1] : '';
  }

  function collectionHandleFromPath(pathname) {
    var path = normalizePath(pathname || window.location.pathname);
    var match = path.match(/\/collections\/([^/?#]+)/);
    return match && match[1] ? match[1] : '';
  }

  function visibleProductCount() {
    var cards = document.querySelectorAll('.shop-product_item, .collection-fast-card, [data-product-handle]');
    return cards ? cards.length : 0;
  }

  function activeCollectionTab() {
    var tab = document.querySelector('.tabs_menu .w-tab-link.w--current, .tabs_menu .w-tab-link[aria-selected="true"], [role="tab"][aria-selected="true"]');
    return tab ? clean(tab.textContent, 80) : '';
  }

  function observeOnce(selector, eventName, detailBuilder, threshold) {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.slice(0, 20).forEach(function (node, index) {
        emit(eventName, typeof detailBuilder === 'function' ? detailBuilder(node, index) : detailBuilder, { onceKey: eventName + ':' + index });
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var node = entry.target;
        observer.unobserve(node);
        var key = node.getAttribute('data-s152-seen-key') || eventName + ':' + Array.prototype.indexOf.call(nodes, node);
        emit(eventName, typeof detailBuilder === 'function' ? detailBuilder(node, nodes.indexOf(node)) : detailBuilder, { onceKey: key });
      });
    }, { threshold: threshold || 0.25 });
    nodes.slice(0, 40).forEach(function (node) {
      observer.observe(node);
    });
  }

  function emitPageEvents() {
    emit('vs_page_context', {}, { onceKey: 'page_context:' + window.location.pathname + window.location.search });
    emit('vs_market_context', {
      event_result: 'seen',
      source_module: 'market_context',
      source_surface: 'page_context'
    }, { onceKey: 'market_context:' + window.location.pathname + window.location.search });

    var query = whitelistedQuery(window.location.search);
    if (query && (query.indexOf('lm_') !== -1 || query.indexOf('qm_source') !== -1)) {
      emit('vs_internal_param_landing', {
        event_result: 'seen',
        source_module: 'internal_attribution',
        landing_bucket: landingBucket()
      }, { onceKey: 'internal_param_landing:' + query });
    }

    if ((context.page_type || '') === 'collection') {
      emit('vs_collection_view', {
        collection_handle: (context.collection && context.collection.handle) || collectionHandleFromPath(),
        active_tab: activeCollectionTab(),
        product_count_visible: visibleProductCount(),
        collection_entry_source: query || referrerType(),
        event_result: 'view'
      }, { onceKey: 'collection_view:' + window.location.pathname });
    }

    if ((context.page_type || '') === 'product') {
      var variant = currentVariant();
      emit('vs_pdp_view', Object.assign({
        product_handle: context.product && context.product.handle,
        event_result: 'view'
      }, variant), { onceKey: 'pdp_view:' + window.location.pathname + ':' + variant.variant_id });
    }

    if ((context.page_type || '') === 'article' || normalizePath(window.location.pathname).indexOf('/blogs/') === 0) {
      emit('vs_content_view', {
        content_type: (context.page_type || '') === 'article' ? 'article' : 'blog',
        content_handle: (context.article && context.article.handle) || (context.blog && context.blog.handle) || '',
        topic_bucket: clean((context.article && context.article.tags && context.article.tags[0]) || '', 80),
        event_result: 'view'
      }, { onceKey: 'content_view:' + window.location.pathname });
    }

    if (normalizePath(window.location.pathname).indexOf('/cart') === 0) {
      emit('vs_cart_view', {
        event_result: 'view',
        source_surface: 'cart_page'
      }, { onceKey: 'cart_view:' + window.location.pathname });
    }
  }

  function bindSeenEvents() {
    observeOnce('.section_hero, .home-hero', 'vs_module_seen', function (node) {
      return {
        source_module: inferModule(node),
        source_surface: 'hero',
        event_result: 'seen'
      };
    }, 0.3);

    observeOnce('.section_meet-the-insoles, .homepage-product-paths, .blog-preview, .home-news-entry, .collection-need-router, .section_shop-products', 'vs_module_seen', function (node, index) {
      return {
        source_module: inferModule(node),
        source_surface: 'section',
        source_position: index + 1,
        event_result: 'seen'
      };
    }, 0.2);

    observeOnce('[data-s152-module="blog_product_module"], .content-commerce-bridge, .article-mentioned-products', 'vs_blog_product_module_view', function (node, index) {
      return {
        content_type: (context.page_type || '') === 'article' ? 'article' : landingBucket(),
        content_handle: (context.article && context.article.handle) || '',
        source_module: inferModule(node),
        source_surface: clean(node.getAttribute('data-vs-content-intent') || node.className || 'blog_product_module', 100),
        source_position: node.getAttribute('data-vs-module-position') || index + 1,
        event_result: 'seen'
      };
    }, 0.25);

    observeOnce('[data-vs-collection-intent-router]', 'vs_collection_intent_router_view', function (node, index) {
      return {
        collection_handle: node.getAttribute('data-collection-handle') || (context.collection && context.collection.handle) || collectionHandleFromPath(),
        source_module: inferModule(node),
        source_surface: 'collection_intent_router',
        source_position: index + 1,
        event_result: 'seen'
      };
    }, 0.25);

    if ((context.page_type || '') === 'collection') {
      observeOnce('.shop-product_item, .collection-fast-card, [data-product-handle]', 'vs_collection_product_card_seen', function (node, index) {
        var link = node.matches && node.matches('a[href*="/products/"]') ? node : node.querySelector('a[href*="/products/"]');
        var href = link ? link.getAttribute('href') : '';
        return {
          collection_handle: (context.collection && context.collection.handle) || collectionHandleFromPath(),
          product_handle: node.getAttribute('data-product-handle') || productHandleFromUrl(href),
          source_position: node.getAttribute('data-card-position') || index + 1,
          source_surface: node.classList && node.classList.contains('collection-fast-card') ? 'collection_fast_card' : 'collection_product_grid',
          event_result: 'seen'
        };
      }, 0.35);
    }

    if ((context.page_type || '') === 'product') {
      observeOnce('[data-pdp-image-grid]', 'vs_pdp_media_seen', function () {
        return Object.assign({
          product_handle: context.product && context.product.handle,
          media_position: 1,
          event_result: 'seen'
        }, currentVariant());
      }, 0.25);
      observeOnce('.section_pdp-reviews, .section_reviews, .reviews_mobile, .reviews-list', 'vs_pdp_reviews_seen', {
        product_handle: context.product && context.product.handle,
        event_result: 'seen'
      }, 0.2);
      observeOnce('.pdp-bxgy, [data-bxgy], .bxgy-promo, .vsf-product-promo', 'vs_pdp_offer_seen', {
        product_handle: context.product && context.product.handle,
        source_surface: 'pdp_offer',
        event_result: 'seen'
      }, 0.2);
      observeOnce('.pdp-sticky-atc, .pdp_floating-cart, [data-pdp-sticky-atc]', 'vs_pdp_sticky_atc_seen', function () {
        return Object.assign({
          product_handle: context.product && context.product.handle,
          event_result: 'seen'
        }, currentVariant());
      }, 0.2);
      observeOnce('[data-vs-pdp-content-entry-bridge]', 'vs_pdp_content_entry_bridge_view', function (node, index) {
        return Object.assign({
          product_handle: node.getAttribute('data-product-handle') || (context.product && context.product.handle),
          source_module: inferModule(node),
          source_surface: 'pdp_content_entry_bridge',
          source_position: index + 1,
          event_result: 'seen'
        }, currentVariant());
      }, 0.25);
    }
  }

  function emitContentClick(link, eventName, extra) {
    var href = link.getAttribute('href') || '';
    emit(eventName, Object.assign({
      content_type: (context.page_type || '') === 'article' ? 'article' : 'blog',
      content_handle: (context.article && context.article.handle) || (context.blog && context.blog.handle) || '',
      destination_path: destinationMeta(href).destination_path,
      destination_query_whitelisted: destinationMeta(href).destination_query_whitelisted,
      source_module: inferModule(link),
      source_surface: clean(link.getAttribute('data-track') || link.className || 'content_link', 120),
      source_position: elementPosition(link, 'a[href]'),
      event_result: 'click'
    }, extra || {}));
  }

  function bindClickEvents() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var contentCommerceLink = target.closest('[data-vs-content-commerce-link]');
      if (contentCommerceLink) {
        var contentCommerceHref = contentCommerceLink.getAttribute('href') || '';
        var contentCommerceDestination = destinationMeta(contentCommerceHref);
        var contentCommerceType = clean(contentCommerceLink.getAttribute('data-vs-destination-type') || landingBucket(contentCommerceDestination.destination_path), 80);
        var contentCommercePayload = {
          content_type: (context.page_type || '') === 'article' ? 'article' : landingBucket(),
          content_handle: (context.article && context.article.handle) || '',
          destination_type: contentCommerceType,
          destination_path: contentCommerceDestination.destination_path,
          destination_query_whitelisted: contentCommerceDestination.destination_query_whitelisted,
          product_handle: contentCommerceLink.getAttribute('data-vs-product-handle') || productHandleFromUrl(contentCommerceHref),
          collection_handle: contentCommerceLink.getAttribute('data-vs-collection-handle') || collectionHandleFromPath(contentCommerceDestination.destination_path),
          content_intent: clean(contentCommerceLink.getAttribute('data-vs-content-intent') || '', 100),
          source_module: inferModule(contentCommerceLink),
          source_surface: clean(contentCommerceLink.className || 'content_commerce_link', 120),
          source_position: contentCommerceLink.getAttribute('data-vs-module-position') || elementPosition(contentCommerceLink, '[data-vs-content-commerce-link]'),
          event_result: 'click'
        };
        emit('vs_blog_product_module_click', contentCommercePayload);
        if (contentCommerceType === 'quick_match' || contentCommerceDestination.destination_path.indexOf('/pages/quick-match') === 0) {
          emit('vs_quick_match_entry_click', Object.assign({}, contentCommercePayload, {
            event_result: 'entry_click'
          }));
        }
      }

      var collectionIntentLink = target.closest('[data-vs-collection-intent-link]');
      if (collectionIntentLink) {
        var collectionIntentHref = collectionIntentLink.getAttribute('href') || '';
        var collectionIntentDestination = destinationMeta(collectionIntentHref);
        emit('vs_collection_intent_router_click', {
          collection_handle: (context.collection && context.collection.handle) || collectionHandleFromPath(),
          collection_intent: clean(collectionIntentLink.getAttribute('data-vs-collection-intent') || '', 100),
          destination_type: clean(collectionIntentLink.getAttribute('data-vs-destination-type') || landingBucket(collectionIntentDestination.destination_path), 80),
          destination_path: collectionIntentDestination.destination_path,
          destination_query_whitelisted: collectionIntentDestination.destination_query_whitelisted,
          product_handle: collectionIntentLink.getAttribute('data-vs-product-handle') || productHandleFromUrl(collectionIntentHref),
          destination_collection_handle: collectionIntentLink.getAttribute('data-vs-collection-handle') || collectionHandleFromPath(collectionIntentDestination.destination_path),
          source_module: inferModule(collectionIntentLink),
          source_surface: 'collection_intent_router',
          source_position: elementPosition(collectionIntentLink, '[data-vs-collection-intent-link]'),
          event_result: 'click'
        });
      }

      var pdpContentBridgeLink = target.closest('[data-vs-pdp-content-bridge-link]');
      if (pdpContentBridgeLink) {
        var pdpContentBridgeHref = pdpContentBridgeLink.getAttribute('href') || '';
        var pdpContentBridgeDestination = destinationMeta(pdpContentBridgeHref);
        var pdpContentBridgeType = clean(pdpContentBridgeLink.getAttribute('data-vs-destination-type') || landingBucket(pdpContentBridgeDestination.destination_path), 80);
        var pdpContentBridgePayload = Object.assign({
          product_handle: context.product && context.product.handle,
          destination_type: pdpContentBridgeType,
          destination_path: pdpContentBridgeDestination.destination_path,
          destination_query_whitelisted: pdpContentBridgeDestination.destination_query_whitelisted,
          collection_handle: pdpContentBridgeLink.getAttribute('data-vs-collection-handle') || collectionHandleFromPath(pdpContentBridgeDestination.destination_path),
          source_module: inferModule(pdpContentBridgeLink),
          source_surface: 'pdp_content_entry_bridge',
          source_position: elementPosition(pdpContentBridgeLink, '[data-vs-pdp-content-bridge-link]'),
          event_result: 'click'
        }, currentVariant());
        emit('vs_pdp_content_entry_bridge_click', pdpContentBridgePayload);
        if (pdpContentBridgeType === 'quick_match' || pdpContentBridgeDestination.destination_path.indexOf('/pages/quick-match') === 0) {
          emit('vs_quick_match_entry_click', Object.assign({}, pdpContentBridgePayload, {
            event_result: 'entry_click'
          }));
        }
      }

      var sizeGuide = target.closest('[data-size-guide-trigger], a[href*="size-guide"], button[class*="size-guide"]');
      if (sizeGuide && (context.page_type || '') === 'product') {
        emit('vs_pdp_size_guide_open', Object.assign({
          product_handle: context.product && context.product.handle,
          source_surface: inferModule(sizeGuide),
          event_result: 'open'
        }, currentVariant()));
      }

      var option = target.closest('.product-option-container .option-pill, .product-option-container select, .size-selector-value, .sex_toggle, [data-pdp-sticky-atc-select]');
      if (option && (context.page_type || '') === 'product') {
        window.setTimeout(function () {
          var container = option.closest && option.closest('.product-option-container[data-option-name]');
          var optionName = clean((container && container.getAttribute('data-option-name')) || option.getAttribute('name') || '');
          var optionValue = clean(option.getAttribute('data-value') || option.value || option.textContent, 120);
          var isSize = optionName.toLowerCase().indexOf('size') !== -1 || option.classList.contains('size-selector-value');
          emit(isSize ? 'vs_pdp_size_select' : 'vs_pdp_variant_select', Object.assign({
            product_handle: context.product && context.product.handle,
            option_name: optionName || (isSize ? 'Size' : 'Variant'),
            option_value: optionValue,
            selected_size: activeOption('size'),
            selected_color: activeOption('color'),
            event_result: 'select'
          }, currentVariant()));
        }, 80);
      }

      var atc = target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], .pdp-sticky-atc button, .pdp_floating-cart button, [data-pdp-sticky-atc-add]');
      if (atc && (context.page_type || '') === 'product') {
        lastAtcIntentAt = Date.now();
        emit('vs_pdp_atc_click', Object.assign({
          product_handle: context.product && context.product.handle,
          source_surface: inferModule(atc),
          selected_size: activeOption('size'),
          selected_color: activeOption('color'),
          event_result: 'click'
        }, currentVariant()));
      }

      var checkout = target.closest('button[name="checkout"], [data-cart-express-checkout], a[href*="/checkout"]');
      if (checkout) {
        var surface = inferModule(checkout);
        emit('vs_checkout_click', {
          source_surface: surface,
          checkout_type: checkout.hasAttribute('data-cart-express-checkout') ? 'express' : 'standard',
          destination_path: destinationMeta(checkout.getAttribute('href') || '/checkout').destination_path,
          event_result: 'click'
        });
      emit('vs_checkout_handoff', {
        source_surface: surface,
        checkout_type: checkout.hasAttribute('data-cart-express-checkout') ? 'express' : 'standard',
        event_result: 'handoff'
      });
      emit('begin_checkout', {
        event_category: 'ecommerce',
        source_surface: surface,
        checkout_type: checkout.hasAttribute('data-cart-express-checkout') ? 'express' : 'standard',
        event_result: 'click'
      });
      }

      var quickMatch = target.closest('.js-open-quick-diagnostic, a[href*="/pages/quick-match"], button[class*="quick"]');
      if (quickMatch) {
        var qmDetail = {
          source_module: inferModule(quickMatch),
          source_surface: clean(quickMatch.getAttribute('data-qd-source') || quickMatch.getAttribute('data-track') || quickMatch.textContent, 100),
          destination_path: destinationMeta(quickMatch.getAttribute('href') || '/pages/quick-match').destination_path,
          source_position: elementPosition(quickMatch, 'a[href], button'),
          event_result: 'open'
        };
        emit('vs_quick_match_open', qmDetail);
        emit('vs_qm_open', qmDetail);
      }

      var productLink = target.closest('a[href*="/products/"]');
      var isHeaderProductLink = productLink && productLink.closest('header, .header, .navbar, .header_mobile, .header_open');
      if (productLink) {
        var href = productLink.getAttribute('href') || '';
        var productDetail = {
          destination_path: destinationMeta(href).destination_path,
          destination_query_whitelisted: destinationMeta(href).destination_query_whitelisted,
          product_handle: productHandleFromUrl(href),
          source_module: inferModule(productLink),
          source_surface: clean(productLink.getAttribute('data-track') || productLink.className || 'product_link', 100),
          source_position: elementPosition(productLink.closest('.shop-product_item, .collection-fast-card, .collection-support-card, article, li') || productLink, '.shop-product_item, .collection-fast-card, .collection-support-card, article, li, a[href*="/products/"]'),
          event_result: 'click'
        };
        if (!isHeaderProductLink && ((context.page_type || '') === 'collection' || normalizePath(window.location.pathname).indexOf('/collections/') === 0)) {
          emit('vs_collection_product_click', Object.assign({
            collection_handle: (context.collection && context.collection.handle) || collectionHandleFromPath(),
            active_tab: activeCollectionTab()
          }, productDetail));
        } else if (normalizePath(window.location.pathname) === '/') {
          emit('vs_home_product_path_click', Object.assign({
            card_title: clean(productLink.textContent, 100)
          }, productDetail));
        } else if (normalizePath(window.location.pathname).indexOf('/blogs/') === 0 || (context.page_type || '') === 'article') {
          emitContentClick(productLink, 'vs_content_product_click', {
            product_handle: productDetail.product_handle
          });
        }
      }

      var collectionLink = target.closest('a[href*="/collections/"]');
      if (collectionLink && !collectionLink.closest('header, .header, .navbar')) {
        var collectionHref = collectionLink.getAttribute('href') || '';
        var collectionDetail = {
          collection_handle: collectionHandleFromPath(destinationMeta(collectionHref).destination_path),
          destination_path: destinationMeta(collectionHref).destination_path,
          source_module: inferModule(collectionLink),
          source_surface: clean(collectionLink.getAttribute('data-track') || collectionLink.className || 'collection_link', 100),
          source_position: elementPosition(collectionLink, 'a[href]'),
          event_result: 'click'
        };
        if (normalizePath(window.location.pathname) === '/') {
          emit('vs_home_need_card_click', Object.assign({
            card_title: clean(collectionLink.textContent, 100)
          }, collectionDetail));
        } else if (normalizePath(window.location.pathname).indexOf('/blogs/') === 0 || (context.page_type || '') === 'article') {
          emitContentClick(collectionLink, 'vs_content_collection_click', collectionDetail);
        } else if ((context.page_type || '') === 'collection') {
          emit('vs_collection_router_click', collectionDetail);
        }
      }

      var articleLink = target.closest('a[href*="/blogs/"]');
      if (articleLink && normalizePath(window.location.pathname) === '/') {
        emit('vs_home_blog_card_click', {
          destination_path: destinationMeta(articleLink.getAttribute('href') || '').destination_path,
          article_handle: destinationMeta(articleLink.getAttribute('href') || '').destination_path.split('/').pop(),
          source_module: inferModule(articleLink),
          source_surface: clean(articleLink.className || 'blog_card', 100),
          source_position: elementPosition(articleLink.closest('article, .home-article_wrapper, .blog-card') || articleLink, 'article, .home-article_wrapper, .blog-card, a[href*="/blogs/"]'),
          event_result: 'click'
        });
      } else if (articleLink && (normalizePath(window.location.pathname).indexOf('/blogs/') === 0 || (context.page_type || '') === 'article')) {
        emitContentClick(articleLink, 'vs_content_related_click');
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if ((context.page_type || '') !== 'product') return;
      if (Date.now() - lastAtcIntentAt < 1200) return;
      lastAtcIntentAt = Date.now();
      emit('vs_pdp_atc_click', Object.assign({
        product_handle: context.product && context.product.handle,
        source_surface: 'product_form_submit',
        selected_size: activeOption('size'),
        selected_color: activeOption('color'),
        event_result: 'submit'
      }, currentVariant()));
    }, true);
  }

  function bindCartEvents() {
    document.addEventListener('valsole:cart:add-success', function (event) {
      var detail = event.detail || {};
      var response = detail.response || {};
      emit('vs_pdp_atc_success', Object.assign({
        product_handle: context.product && context.product.handle,
        source_surface: detail.surface || 'pdp',
        cart_item_count: toNumber(detail.cart_item_count || response.item_count || context.cart_item_count),
        event_result: 'success'
      }, currentVariant()));
      emit('add_to_cart', Object.assign({
        event_category: 'ecommerce',
        source_surface: detail.surface || 'pdp',
        cart_item_count: toNumber(detail.cart_item_count || response.item_count || context.cart_item_count),
        event_result: 'success'
      }, currentVariant()));
    });

    document.addEventListener('valsole:cart:add-error', function (event) {
      var detail = event.detail || {};
      emit('vs_pdp_atc_error', Object.assign({
        product_handle: context.product && context.product.handle,
        source_surface: detail.surface || 'pdp',
        error_code: clean(detail.status || detail.code || '', 40),
        error_message_short: clean(detail.message || 'Add to cart failed', 120),
        event_result: 'error'
      }, currentVariant()));
    });

    document.addEventListener('valsole:cart:add-success', function () {
      emit('vs_cart_open', {
        source_surface: 'post_add_cart_drawer',
        event_result: 'open'
      });
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var cartOpen = target.closest('a[href="/cart"], a[href*="/cart"], [data-cart-open], .cart-button, .cart-icon, .navbar_cart-button');
      if (cartOpen && !target.closest('a[href*="/cart/add"]')) {
        emit('vs_cart_open', {
          source_surface: inferModule(cartOpen),
          event_result: 'open'
        });
      }

      var quantity = target.closest('[data-cart-quantity], .cart-quantity button, .quantity button, button[name="plus"], button[name="minus"]');
      if (quantity) {
        emit('vs_cart_quantity_change', {
          source_surface: inferModule(quantity),
          change_direction: clean(quantity.getAttribute('name') || quantity.getAttribute('aria-label') || quantity.textContent, 40),
          event_result: 'click'
        });
      }

      var remove = target.closest('a[href*="/cart/change"], button[name="remove"], [data-cart-remove], .cart-remove');
      if (remove) {
        emit('vs_cart_remove', {
          source_surface: inferModule(remove),
          event_result: 'click'
        });
      }
    }, true);
  }

  function bindQuickMatchEvents() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var stepAnswer = target.closest('[data-step], [data-question], .qd-option, .quiz-option, .quick-diagnostic-option');
      if (stepAnswer && (stepAnswer.closest('.quick-diagnostic') || stepAnswer.closest('[id*="quick"]') || normalizePath(window.location.pathname).indexOf('/pages/quick-match') === 0)) {
        emit('vs_qm_step_complete', {
          step_id: clean(stepAnswer.getAttribute('data-step') || stepAnswer.getAttribute('data-question') || '', 80),
          step_label: clean(stepAnswer.closest('[data-step-label]') && stepAnswer.closest('[data-step-label]').getAttribute('data-step-label'), 100),
          answer_value: clean(stepAnswer.getAttribute('data-value') || stepAnswer.textContent, 120),
          event_result: 'complete'
        });
      }

      var qmProduct = target.closest('.quick-diagnostic a[href*="/products/"], [id*="quick"] a[href*="/products/"], .vsf-result a[href*="/products/"]');
      if (qmProduct) {
        emit('vs_qm_product_click', {
          recommended_product_handle: productHandleFromUrl(qmProduct.getAttribute('href') || ''),
          destination_path: destinationMeta(qmProduct.getAttribute('href') || '').destination_path,
          event_result: 'click'
        });
      }

      var qmClose = target.closest('.quick-diagnostic [aria-label*="Close"], .quick-diagnostic .close, [id*="quick"] [aria-label*="Close"]');
      if (qmClose) {
        emit('vs_qm_close', {
          source_surface: inferModule(qmClose),
          event_result: 'close'
        });
      }
    }, true);
  }

  function init() {
    emitPageEvents();
    bindSeenEvents();
    bindClickEvents();
    bindCartEvents();
    bindQuickMatchEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
